import { makeStyles } from "@material-ui/core/styles";
import { splitByBoolean } from "../../../../../../../../../../common/util/Array/orderByBoolean";
import ShurikenProgress from "../../../../../../../../Animations/ShurikenProgress";
import { Markdown } from "../../../../../../../../Markdown";
import { openOtherUserPanel } from "../../../../../../../../User/OtherUserPanel/functions";
import { User, UserForRanking } from "../../../../../../../../User/types";
import { Post, PostComment } from "../../../../../types";
import { UserNameAndTime } from "../../UserNameAndTime";
import { CommentLowerButtonArea } from "./CommentLowerButtonArea";
import {
    getDeleteComment,
    getLikeComment,
    getUnlikeComment,
} from "./functions";

export function CommentRightContents({
    post,
    comment,
    user,
    tmpMutedUserIds,
    setTmpMutedUserIds,
    comments,
    setComments,
    setCommentedUsers,
    deleteComment,
    commentedUser,
    commentsAndLikesThisComment,
    showReply,
    replyTargetUser,
}: {
    post: Post;
    comment: PostComment;
    user?: User;
    tmpMutedUserIds: number[];
    setTmpMutedUserIds: (ids: number[]) => void;
    comments: PostComment[];
    setComments: (comments: PostComment[]) => void;
    setCommentedUsers: (users: UserForRanking[]) => void;
    deleteComment: (
        targetComment: PostComment,
        deleteFromServerSie: () => Promise<void>
    ) => Promise<void>;
    commentedUser: UserForRanking;
    commentsAndLikesThisComment: PostComment[];
    showReply: () => void;
    replyTargetUser: UserForRanking | undefined;
}) {
    const [likesToThisComment, commentsToThisComment] = splitByBoolean(
        commentsAndLikesThisComment,
        com => com.isLike
    );

    const isMyComment = comment.commentedUserId === user?.userId;
    const showLowerButtons = !comment.isLike;

    const c = useStyles();

    return (
        <div className={c.container}>
            <UserNameAndTime
                postedUser={commentedUser}
                minutesAgo={comment.minutesAgo}
            />

            {replyTargetUser && (
                <span
                    className={c.replyTargetUser}
                    onClick={ev => {
                        ev.stopPropagation();
                        openOtherUserPanel(replyTargetUser.userId);
                    }}
                >
                    To: {replyTargetUser.name}
                </span>
            )}

            <div
                className={
                    showLowerButtons
                        ? c.markdownWithButtons
                        : c.markdownWithoutButtons
                }
            >
                {comment.text || comment.isLike ? (
                    <Markdown
                        source={
                            comment.isLike
                                ? `Liked by ${commentedUser.name}! \`❤️\``
                                : comment.text
                        }
                        noParagraphMarginBottom
                        singleBreakLine
                        isSocialPost
                        isFontSmaller
                        style={{ fontSize: "medium" }}
                    />
                ) : (
                    <ShurikenProgress size="7%" />
                )}
            </div>

            {showLowerButtons && (
                <CommentLowerButtonArea
                    user={user}
                    comment={comment}
                    tmpMutedUserIds={tmpMutedUserIds}
                    setTmpMutedUserIds={setTmpMutedUserIds}
                    isMyComment={isMyComment}
                    hasOwnLike={likesToThisComment.some(
                        com => com.commentedUserId === user?.userId
                    )}
                    deleteComment={getDeleteComment(
                        post,
                        comment,
                        deleteComment
                    )}
                    likeComment={getLikeComment(
                        post,
                        comment,
                        comments,
                        setComments,
                        setCommentedUsers,
                        showReply
                    )}
                    unlikeComment={getUnlikeComment(
                        post,
                        comment,
                        comments,
                        deleteComment
                    )}
                    likeCount={likesToThisComment.length}
                    commentCount={commentsToThisComment.length}
                />
            )}
        </div>
    );
}
const useStyles = makeStyles(theme => ({
    container: { width: "100%" },
    markdownWithButtons: {
        marginBottom: 5,
        paddingBottom: 10,
        paddingTop: 10,
        borderBottom: `solid 1px ${theme.palette.grey[100]}`,
    },
    markdownWithoutButtons: {
        marginBottom: 5,
        paddingTop: 5,
    },
    replyTargetUser: { color: theme.palette.primary.main, cursor: "pointer" },
}));
